import * as yup from "yup";

export const userSchema = yup.object().shape({
  email: yup.string().email().required("Please enter a valid email address"),
  password: yup.string(),
});